import React, { createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import useFlagSystemCapability from '../hooks/useFlagSystemCapability';
import { flagAccount } from '../utils/flagSystem';

const FlagSystemCapabilityContext = createContext(null);

export const FlagSystemCapabilityProvider = ({ children }) => {
  const { accessContext } = useAuth();
  const location = useLocation();
  const account = flagAccount(accessContext);
  const customer = accessContext && accessContext.role === 'CustomerLevelUser';
  const capability = useFlagSystemCapability(account.isCustomer && !account.error ? account.customerId : null, location.key);
  const value = customer && account.error ?
    { ...capability, enabled: false, status: 'error', error: account.error, canRetry: false } : capability;
  return <FlagSystemCapabilityContext.Provider value={value}>{children}</FlagSystemCapabilityContext.Provider>;
};

export const useCustomerFlagSystemCapability = () => {
  const capability = useContext(FlagSystemCapabilityContext);
  if (!capability) throw new Error('Flag System capability must be read within its support layout.');
  return capability;
};
